"use client";
import useWebview from "@/webview/useWebview";
import type { LinkListItemProps } from "./types";
import { cn } from "@/lib/utils";

export default function LinkListItem({
  label,
  url,
  className = "",
  variant = "link",
  ...beam_props
}: LinkListItemProps) {
  const { getUrl } = useWebview();
  const commonClasses =
    "rounded-[8px] text-sm no-underline py-1 px-2 hover:no-underline";
  const variants = {
    chip: `bg-white text-black border border-putty-light hover:border-primary hover:bg-primary hover:text-white ${commonClasses}`,
    chipDark: `bg-primary-light text-white hover:bg-white hover:text-primary-light ${commonClasses}`,
    link: "text-base underline decoration-primary-light hover:decoration-primary",
  };
  return (
    <a
      href={getUrl(url)}
      className={cn(`${variants[variant]}`, className)}
      {...beam_props}
    >
      {label}
    </a>
  );
}
